// getIsCaptchaVerified.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';
import getCaptchaHeaders, {
  getCaptchaProvider,
} from '../selector/getCaptchaHeaders.js';

/**
 * Check if CAPTCHA verification is complete
 *
 * Logic:
 * - If CAPTCHA is not configured (provider === null): returns true, means we don't need to verify CAPTCHA
 * - If CAPTCHA is configured: check if verification headers exist and are not empty.
 * @kind selector
 * @param {Immutable.Map} state - root state
 * @return {boolean} true if CAPTCHA is verified
 */
const getIsCaptchaVerified = createSelector(
  state => getCaptchaProvider(state),
  state => getCaptchaHeaders(state),
  (captchaProvider, captchaHeaders) => {
    if (captchaProvider === null) {
      return true;
    }

    // CAPTCHA configured, check if verification headers exist and are not empty
    if (
      !captchaHeaders ||
      typeof captchaHeaders !== 'object' ||
      Object.keys(captchaHeaders).length === 0
    ) {
      return false;
    }

    return true;
  }
);

export default getIsCaptchaVerified;
